import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.orderCenterOrderList,
    component: () => import('../../pages/OrderCenter/OrderList'),
    meta: { title: '订单列表' }
  }
] as TRoutes[]
